import styled, { css } from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../components/Button';

export const StyledWidgetPickerButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  margin: 0 auto 16px;

  path {
    fill-opacity: 1;
  }
`;

export const StyledWidgetPickerList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const StyledWidgetPickerItem = styled.div<{
  isSelected: boolean;
  isDisabled: boolean;
  isDragging: boolean;
}>`
  padding: 24px;
  background-color: ${colorsPalettes.carbon[0]};
  ${setFontVariant('input2', colorsPalettes.carbon[500])};
  border: none;
  border-bottom: ${({ isDisabled }) => (isDisabled ? `1px solid ${colorsPalettes.carbon[100]}` : 'none')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  width: 100%;
  transition: background-color 3ms ease-out;

  &:hover {
    background-color: ${({ isDisabled, isDragging }) =>
      isDisabled || isDragging ? colorsPalettes.carbon[0] : colorsPalettes.carbon[25]};
  }

  ${({ isDragging }) =>
    isDragging &&
    css`
      background: ${colorsPalettes.carbon[0]};
      box-shadow:
        0px 0px 8px 0px rgba(0, 0, 0, 0.12),
        0px 8px 8px 0px rgba(0, 0, 0, 0.24);
    `}
`;

export const StyledWidgetPickerItemText = styled.span`
  flex: 1 0 auto;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
`;

export const StyledDragIcon = styled(SWReactIcons)`
  path:last-child {
    fill: ${colorsPalettes.carbon[300]};
  }
`;
